import React from "react";

import CardSubscription from "../components/CardSubscription";
import ShopHeader from "../components/ShopHeader";
import Loading from "../../loading/pages/Loading";
import Failed from "../../loading/pages/Failed";
import { getRequest, postRequest } from "../../api/axiosRequests";
import { PALETTE } from "../../common/ThemeConstants";
import { Features } from "../../common/SubscriptionFeatures";

import Cookies from "js-cookie";
import { useState, useEffect } from "react";
import Col from "react-bootstrap/Col";
import SubscriptionFeatureList from "../components/SubscriptionFeatureList";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { useAuth } from "../../auth/hook";

export default function Subscriptions() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFailed, setIsFailed] = useState(false);

  const auth = useAuth();

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise = getRequest("subscriptions/", headers);

    promise
      .then((res) => {
        setSubscriptions(res.data);
        setIsLoaded(true);
        setIsFailed(false);
        setIsLoaded(true);
      })
      .catch((errs) => {
        console.log(errs);
        setIsFailed(true);
        setIsLoaded(true);
      });
  }

  const createSessionCheckout = (id) => {
    if (!auth.user.email || !auth.user.cf) {
      alert(
        "Completa il tuo profilo per procedere all'acquisto! Vai alle impostazioni e inserisci il Codice Fiscale."
      );
      return true;
    }
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      "X-CSRFToken": csrftoken,
      Authorization: localStorage.getItem("jwt"),
    };
    const promise = postRequest(
      "createSubscriptionCheckoutSession/",
      { idSubscription: id },
      headers
    );
    promise
      .then((res) => {
        window.location.href = res.data.checkoutUrl;
        return false;
      })
      .catch((errs) => {
        console.log(errs);
        return true;
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <ShopHeader />
      <ContainerResponsive>
        {!isLoaded && <Loading />}
        {isLoaded && isFailed && (
          <Failed
            separatorText={""}
            mainDescription={"No subscriptions available."}
          />
        )}
        {isLoaded && !isFailed && (
          <div>
            {subscriptions.length > 0 && (
              <>
                <div
                  className="d-flex flex-nowrap m-auto py-2"
                  style={{ maxWidth: "fit-content", overflowX: "auto" }}
                >
                  {subscriptions.map((subscription, idx) => (
                    <Col key={subscription.id + 1} className="my-2 mx-2">
                      <CardSubscription
                        to={""}
                        height={300}
                        width={300}
                        color={PALETTE.WHITE}
                        backgroundColor={PALETTE.LIGHTGRAY}
                        backgroundColorHover={PALETTE.DARKGRAY}
                        close={false}
                        subscription={subscription}
                        onSubmit={createSessionCheckout}
                      />
                    </Col>
                  ))}
                </div>
                <div className="py-4 m-auto" style={{ maxWidth: 420 }}>
                  <SubscriptionFeatureList
                    features={Features}
                    color={PALETTE.GRADIENTLIGHT}
                  />
                </div>
              </>
            )}
            {subscriptions.length === 0 && (
              <Failed
                separatorText={""}
                mainDescription={"No subscriptions available."}
                secondaryDescription={""}
              />
            )}
          </div>
        )}
      </ContainerResponsive>
    </>
  );
}
